export default __webpack_public_path__ + "static/media/project3.54bfaf43.png";